export enum SourceType {
  REPORT = 1,
  REQUEST = 4
}
